import { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { T } from "../tokens";
import { useThemeStore } from "../store/theme";

/** Sun/Moon icon button that flips light ↔ dark (persists the choice). */
export function ThemeToggle() {
  const mode   = useThemeStore((s) => s.mode);
  const toggle = useThemeStore((s) => s.toggle);
  const [h, setH] = useState(false);
  const isDark = mode === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      style={{
        width: 34, height: 34, borderRadius: 8,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: h ? T.s2 : "transparent",
        border: `1px solid ${h ? T.b1 : "transparent"}`,
        color: h ? T.t0 : T.t2, cursor: "pointer", transition: "all 0.12s ease",
      }}
    >
      {isDark ? <Sun size={16}/> : <Moon size={16}/>}
    </button>
  );
}
